import React, { useState } from "react";
import { IoIosClose } from "react-icons/io";
import LineLogo from "../../../assets/LineLogo.png";
import { GoVerified } from "react-icons/go";
import { toast } from "react-toastify";
import { updateDocumentStatus } from "../../../API/employee";
import { useParams } from "react-router-dom";
import { func } from "prop-types";

function RejectDocument({ onClickHandler, openedDoc, getDetails }) {
  const { id } = useParams();

  //const [openedDoc, setOpenedDoc] = useState({ document: "", text: "" });
  const [getReason, setGetReason] = useState("");
  const [status, setStatus] = useState(0);
  const [loading, setLoading] = useState(false);

  function getReasonForReject(event) {
    event.preventDefault();

    console.log(openedDoc, id, status, getReason);
    if (getReason === "") {
      toast("Please Mention the Reason", {
        type: "warning",
        position: "top-right",
        autoClose: 2000,
        theme: "colored",
      });
    } else {
      setLoading(true);
      updateDocumentStatus(id, openedDoc, status, getReason)
        .then((response) => {
          console.log("Response during rejection", response);
          if (response?.data) {
            toast("Reason has been sent to the employee", {
              type: "success",
              position: "top-right",
              autoClose: 2000,
              theme: "colored",
            });
          }

          console.log("success");
          onClickHandler();
          getDetails(id);
          setLoading(false);
        })
        .catch((error) => {
          console.log("Reject error", error);
          toast("Something went wrong!", {
            type: "error",
            position: "top-right",
            autoClose: 2000,
            theme: "colored",
          });
          setLoading(false);
        });
    }
    // localStorage.setItem("rejectionResponse", getReason);
    // window.location.reload();
  }

  const handleChange = (event) => {
    setGetReason(event.target.value);
  };

  return (
    <div
      style={{
        position: "fixed",
        left: "0",
        right: "0",
        top: "0",
        bottom: "0",
        height: "100vh",
        width: "100%",
        background: " rgba(0, 0, 0, 0.5)",
        zIndex: "1218",
      }}
    >
      <div className="mx-auto sm:px-10 top-10 mt-20 md:container md:mx-auto  justify-between items-center">
        <div
          style={{
            width: window.innerWidth > 600 ? "500px" : window.innerWidth - 20,
            //height: window.innerHeight > 700 ? "200px" : "200px",

            position: "fixed",
            background: "white",
            left: "0",

            right: "0",
            margin: "auto",
            borderRadius: "10px",
          }}
          className="shadow-[0_35px_60px_-15px_rgba(0,0,0,0.3)] p-2"
        >
          {/* <IoIosClose
            className="float-right cursor-pointer"
            size={25}
            onClick={onClickHandler}
          /> */}
          <div style={{ marginLeft: "35px" }}>
            <div>
              <h6 className="text-sm sm:text-lg font-bold mb-3 pt-1">
                Rejected Documents Report
              </h6>
            </div>
            <div>
              <p className="text-sm text-[#0e0d0d] float-left w-3/4  mb-3 mt-3md:ml-2">
                Type the reason for rejection of the below documents
              </p>
            </div>
            <div className="mb-5">
              <img src={LineLogo} alt="" />
            </div>
            <div>
              <div className=" mb-2 sm:mb-5">
                <p className="text-[#5F5F5F] text-md mb-1">{openedDoc}</p>
                <textarea
                  rows="2"
                  className="text-slate-700  w-11/12 p-2 border mt-1 rounded-lg hover:border-[#3C69DF]"
                  type={getReason}
                  value=""
                  placeholder="Reason for rejection"
                  onChange={(event) => {
                    handleChange(event);
                    // console.log("Rejection reason", getReason);
                  }}
                />
              </div>
              <div className="my-4 flex justify-end  ">
                <div className="self-end">
                  <button
                    onClick={onClickHandler}
                    className="px-4 py-1 text-bold rounded-md text-blue-800 border-2 border-buttonColor hover:bg-slate-100 "
                  >
                    Cancel
                  </button>
                  <span className="mx-2" />
                  <button
                    onClick={(event) => {
                      getReasonForReject(event);
                    }}
                    className="px-4 py-1   border-2 border-buttonColor rounded-lg bg-[#3C69DF] hover:bg-[#284ba3] text-white text-bold"
                  >
                    {loading ? (
                      <svg
                        class="inline mr-2 w-8 h-8  animate-spin text-white fill-blue-600"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                          fill="currentColor"
                        />
                        <path
                          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                          fill="currentFill"
                        />
                      </svg>
                    ) : (
                      " Send Reason"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RejectDocument;
